/**
 * Decoration Pack Engine — bundles of ornament decisions.
 *
 * A pack maps a mood onto the Design Engine's decoration style plus the
 * shape-style gene the DNA carries. Packs exist so a category can say
 * "salon gets soft organic shapes" as one decision instead of three.
 */

export const DECORATION_PACKS = {
  clean: {
    id: 'clean', name: 'Clean',
    engineStyle: 'none', shapeStyle: 'none',
  },
  'soft-minimal': {
    id: 'soft-minimal', name: 'Soft Minimal',
    engineStyle: 'minimal', shapeStyle: 'rounded',
  },
  'organic-flow': {
    id: 'organic-flow', name: 'Organic Flow',
    engineStyle: 'organic', shapeStyle: 'organic',
  },
  'geo-pop': {
    id: 'geo-pop', name: 'Geo Pop',
    engineStyle: 'geometric', shapeStyle: 'angular',
  },
};

export const listDecorationPacks = () =>
  Object.values(DECORATION_PACKS).map(({ id, name }) => ({ id, name }));

export const getDecorationPack = (id) => {
  const pack = DECORATION_PACKS[id];
  if (!pack) throw new Error(`Unknown decoration pack "${id}"`);
  return pack;
};
